import React, {useState, useEffect} from 'react';
import {Navigate} from 'react-router-dom'

import logo from '../../assets/DiagoRisk-logoRVB.png'
import mans from '../../assets/le_mans.png'
import RA from '../../assets/cartes_RA.png'
import star1 from '../../assets/scintillait.png'
import star2 from '../../assets/scintillait_bleue.png'
import star3 from '../../assets/scintillait_vert.png'
import mascotte from '../../assets/Mascotte/Neutre-YC.png'
import composit1 from '../../assets/Composit_6_1.JPG'
import composit2 from '../../assets/Composit_6_2.JPG'

import Nav from '../MEP/SWNav'
import FooterSW from '../MEP/footer_SW';


function Accueil() {

  const [idAgent, setidAgent] = useState();
  const [role, setrole] = useState();

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem('idAgent'));
    const items2 = JSON.parse(localStorage.getItem('role'));
    if (items) {
      setidAgent(items);
      setrole(items2)
    }
  }, []);

  const [goToLocalisation, setGoToLocalisation] = useState(false)
  const [goToConnexion, setGoToConnexion] = useState(false)
  const [goToSimulation, setGoToSimulation] = useState(false)
  const [goToInscription, setGoToInscription] = useState(false)
  const [goToDR50, setGoToDR50] = useState(false)


  function handleSubmitLoca(event) {
    event.preventDefault()
    setGoToLocalisation(true)
  }

  function handleSubmitAccesCompte(event) {
    event.preventDefault()
    if(idAgent !== undefined) {
      setGoToSimulation(true)
    }
    else {
      setGoToConnexion(true)
    }
  }
  function handleSubmitInscription(event) {
    event.preventDefault()
    setGoToInscription(true)
  }
  function handleSubmitDR50(event) {
    event.preventDefault()
    setGoToDR50(true)
  }

  if(goToLocalisation) {
      return <Navigate push to={`/ma_localisation`} />
  }
  if(goToConnexion) {
    return <Navigate push to={`/connexion`} />
  }
  if(goToSimulation) {
    return <Navigate push to={`/simulations`}/>
  }
  if(goToInscription) {
    return <Navigate push to={`/abonnements`}/>
  }
  if(goToDR50) {
    return <Navigate push to={`/diagorisk2050`}/>
  }

  return (
    <div>
      <div className="accueil" >
          <Nav/>
          <div className='PremierBlocAccueil'>
            <img src={composit2} alt="composit" className="compositIMGAccueil"/>
            <div className="principal" >
              <div className='top'>
                <div className="top1">
                  <img src={logo} alt="logo_diagorisk" className="App-logo"/>
                </div>
                <div className="top2">
                <h2>Avec le concours scientifique de </h2>	
                  <img src={mans} alt="logo_le_mans" className="Mans-logo"/>
                </div>
              </div>

              <div className="bottom">
                <button onClick={handleSubmitInscription} className='buttonAccueil buttonActive'> Souscrire </button>
                <button onClick={handleSubmitAccesCompte} className='buttonAccueil buttonActive'> Accéder à mon compte </button>
                <button onClick={handleSubmitLoca} className= 'buttonAccueil buttonActive'> Découvrir DiagoRisk </button>
              </div>
            </div>
            <img src={composit1} alt="composit" className="compositIMGAccueil"/>
          </div>
      </div>

      <div className='column'>
        <div className='cardAccueil cardAccueil2' style={{backgroundColor:'rgb(123, 195, 97)'}}>
          <img src={RA} alt="" className="imageAccueil"/>
          <div className='textCardAccueil textCardAccueil2' style={{marginLeft:'5%'}}>
            <b>Pour renforcer la résilience de chaque exploitation, DiagoRisk aide les acteurs agri / agro à répondre à 3 questions clés :</b>
            <ul>
              <li style={{color:'black'}}> <div className='lila'> Combien me coûte mon risque climatique aujourd’hui ? </div> </li>
              <li style={{color:'black'}}> <div className='lila'> Quels seront les cultures les plus menacées en 2035 et en 2050 ? Par quels aléas ? </div> </li>
              <li style={{color:'black'}}> <div className='lila'>  Quelles sont les solutions les plus efficaces ? </div> </li>
            </ul>
          </div>
        </div>



        <div className='cardAccueil cardAccueil2' style={{backgroundColor:'white'}}>
          <div className='textCardAccueil textCardAccueil2'>
            <div className='titreBleuAccueil' style={{textAlign:'start'}}> Nous vous aidons pour :</div>
            <ul>
              <li style={{color:'black'}}> <div className='lila'>Chiffrer les enjeux </div> </li>
              <li style={{color:'black'}}> <div className='lila'> Définir une stratégie d’adaptation </div> </li>
              <li style={{color:'black'}}> <div className='lila'> Choisir un plan d’action réaliste en comparant les solutions techniques et financières </div> </li>
              <li style={{color:'black'}}> <div className='lila'> Tester son efficacité et sa robustesse en cas d’accélération du réchauffement </div> </li>
              <li style={{color:'black'}}> <div className='lila'> Le décliner chez chacun de vos partenaires pour les mobiliser </div> </li>
            </ul>
          </div>
          <img src={mascotte} alt="" className="imageAccueil"/>
        </div>

        <div className='cardAccueil cardAccueil2' style={{backgroundColor:'rgb(206, 234, 175)'}}>
          <div className='textCardAccueil2' style={{width:'85%', marginRight:'0px'}}>
            <div className='titreBleuAccueil' style={{textAlign:'center',width:'100%'}}>Vous souhaitez renforcer la résilience des agriculteurs et les accompagner face aux risques ! Nous vous aidons pour :</div>
            <ul style={{width:'60%', marginLeft:'20%'}}>
              <li style={{color:'black'}}> <div className='lila'>  Prototyper des solutions et en mesurer l'efficacité </div> </li>
              <li style={{color:'black'}}> <div className='lila'>  Evaluer le risque sur un portefeuille, une filière et/ou un territoire </div> </li>
              <li style={{color:'black'}}> <div className='lila'>  Ajuster l'accompagnement selon la situation de chaque agriculteur et sa capacité à adopter de nouvelles pratiques </div> </li>
            </ul>
          </div>
        </div>

        <div className='cardAccueil cardAccueil2 accueil cardAccueilImage2'>
          <div className='textCardAccueil textCardAccueil2 titreImage2Accueil'>
          Le moteur de calcul a été développé en partenariat avec l’Institut du Risque et de l’Assurance de l’Université du Mans et valorise :
          </div>
          <img src={star3} alt="" className="imageAccueil starAccueil"/>
          <img src={star1} alt="" className="imageAccueil starAccueil"/>
          <img src={star2} alt="" className="imageAccueil starAccueil"/>
        </div>

        <div className='titreAccueil' style={{color:'#92D050', marginBottom:'20px', marginTop:'20px'}}>
          Notre objectif est de répondre aux questions de 80% des agriculteurs et viticulteurs.
        </div>

      </div>
      <FooterSW/>
    </div>
  );
}

export default Accueil;

